import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  fetchBannerById,
  fetchBannersData,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import { baseURL } from "../../services/axios/eps";

const ReviewBanner = () => {
  const { bannerId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [bannersData, setBannersData] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  const getdata = async () => {
    let res;
    if (bannerId) {
      res = await fetchBannerById(bannerId);
      if (res?.data?.success && res.data?.data) {
        setBannersData([res.data.data]);
      } else {
        handleErrors(res, navigate, "Review Home Banner: ");
      }
    } else {
      res = await fetchBannersData();
      if (res?.data?.success && res?.data?.data) {
        setBannersData(res.data.data);
      } else {
        handleErrors(res, navigate, "Review Home Banner: ");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getdata();
  }, [bannerId]);

  const nextSlide = () => {
    if (bannersData.length > 0) {
      setCurrentSlide((prev) => (prev + 1) % bannersData.length);
    }
  };

  const prevSlide = () => {
    if (bannersData.length > 0) {
      setCurrentSlide((prev) => (prev - 1 + bannersData.length) % bannersData.length);
    }
  };

  useEffect(() => {
    if (bannersData.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % bannersData.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [bannersData.length]);

  const customStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Khula:wght@400;700&display=swap');
    
    .btn-wrapper {
      position: relative;
      display: inline-block;
      margin-top: 25px;
    }

    .btn--secondary {
      padding: 14px 30px 12px;
      font-weight: 700;
      background-color: #45f882;
      color: #1d2329;
      position: relative;
      z-index: 1;
      overflow: hidden;
      clip-path: polygon(0% 0%, 100% 0%, 100% 65%, 85% 100%, 0% 100%);
      letter-spacing: 1px;
      font-size: 18px;
      border: none;
      cursor: pointer;
      font-family: Arial, sans-serif;
      text-transform: uppercase;
      transition: all 0.3s ease;
    }

    .btn--secondary::before,
    .btn--secondary::after {
      content: "";
      position: absolute;
      inset: 0px;
      transition: all 0.5s ease;
      z-index: -1;
    }

    .btn--secondary::before {
      right: -100px;
      border-right: 100px solid transparent;
      border-bottom: 100px solid #faab07;
      transform: translateX(-100%);
    }

    .btn--secondary::after {
      left: -100px;
      border-left: 100px solid transparent;
      border-top: 100px solid #faab07;
      transform: translateX(100%);
    }

    .btn--secondary:hover {
      color: #fff;
    }

    .btn--secondary:hover::before {
      transform: translateX(-49%);
    }

    .btn--secondary:hover::after {
      transform: translateX(49%);
    }
  `;

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          backgroundColor: "#141C30",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading Preview...</span>
        </div>
      </div>
    );
  }

  if (bannersData.length === 0) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          backgroundColor: "#141C30",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <h3 className="mb-4">No banners available to review</h3>
        <button
          onClick={() => navigate("/home-banner")}
          className="btn btn-success"
        >
          Back to Banners
        </button>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: "0px", overflow: "hidden", position: "relative" }}>
      <style>{customStyles}</style>

      {/* Floating Back Button */}
      <button
        onClick={() => navigate("/home-banner")}
        style={{
          position: "absolute",
          top: "30px",
          left: "30px",
          zIndex: 10,
          padding: "10px 20px",
          backgroundColor: "rgba(20, 28, 48, 0.85)",
          color: "#fff",
          border: "1px solid #ffffff30",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "600",
          fontFamily: "Arial, sans-serif",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          transition: "background-color 0.2s",
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(20, 28, 48, 1)"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(20, 28, 48, 0.85)"}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back to Banners
      </button>

      {/* Banner Slider Container */}
      <div
        style={{
          width: "100%",
          height: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            width: `${bannersData.length * 100}%`,
            height: "100%",
            transform: `translateX(-${currentSlide * (100 / bannersData.length)}%)`,
            transition: "transform 0.6s ease-in-out",
          }}
        >
          {bannersData.map((slide, index) => {
            const mediaUrl = `${baseURL}/uploads/file/${slide.bg_image}`;
            return (
              <div
                key={index}
                style={{
                  width: `${100 / bannersData.length}%`,
                  height: "100%",
                  position: "relative",
                  overflow: "hidden",
                  backgroundColor: "#141C30",
                }}
              >
                {slide.banner_type === "video" ? (
                  <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  >
                    <source src={mediaUrl} />
                  </video>
                ) : (
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundImage: `url('${mediaUrl}')`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                )}

                {/* Top Overlay */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "297px",
                    background: "linear-gradient(359deg, rgba(20, 28, 48, 0) 0%, #141C30 86.5%)",
                    zIndex: 1,
                  }}
                />

                {/* Bottom Overlay */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "395px",
                    background: "linear-gradient(180deg, rgba(20, 28, 48, 0) 0%, #141C30 86.5%)",
                    zIndex: 1,
                  }}
                />

                {/* Content Overlay */}
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "24px",
                  }}
                >
                  <div style={{ color: "#fff" }}>
                    <p
                      style={{
                        margin: "0 0 8px 0",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "clamp(16px, 2vw, 28px)",
                        fontWeight: 700,
                        lineHeight: 1.2,
                        color: "#FFFFFF",
                      }}
                    >
                      {slide.sub_heading}
                    </p>

                    <h1
                      style={{
                        margin: "0",
                        fontFamily: '"Bebas Neue", "Anton", "Arial Narrow", sans-serif',
                        fontSize: "clamp(40px, 8vw, 72px)",
                        fontWeight: 400,
                        lineHeight: 0.9,
                        letterSpacing: "1px",
                        color: "#FFFFFF",
                        textTransform: "uppercase",
                        textShadow: "4px 4px 0 #00E5FF, -1px -1px 0 #00E5FF, 1px -1px 0 #00E5FF, -1px 1px 0 #00E5FF",

                        maxWidth: "900px",
                        marginInline: "auto",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {slide.heading}
                    </h1>

                    <p
                      style={{
                        margin: "18px auto 0",
                        maxWidth: "760px",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "18px",
                        fontWeight: 400,
                        lineHeight: 1.45,
                        color: "#FFFFFF",
                      }}
                    >
                      {slide.details}
                    </p>

                    {slide.button_enabled === 1 && slide.button_text && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div className="btn-wrapper">
                          <button
                            className="btn--secondary"
                            onClick={() => {
                              if (slide.button_url) {
                                window.open(slide.button_url, "_blank");
                              }
                            }}
                          >
                            {slide.button_text}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Carousel Indicators / Navigation Buttons */}
        {bannersData.length > 1 && (
          <div
            style={{
              position: "absolute",
              right: "30px",
              bottom: "25px",
              zIndex: 5,
              display: "flex",
              gap: "15px",
              alignItems: "center",
            }}
          >
            <div
              onClick={prevSlide}
              style={{
                width: "51px",
                height: "51px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: "1px solid #FFFFFF",
              }}
            >
              <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.48 17.5L1.47998 9.5L10.48 1" stroke="black" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>

            <div
              onClick={nextSlide}
              style={{
                width: "51px",
                height: "51px",
                backgroundColor: "#D9D9D94D",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                border: "1px solid #FFFFFF",
              }}
            >
              <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L10 9L1 17.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewBanner;
